// extracted by mini-css-extract-plugin
export default {"navLayout":"AccessHeaderNav_navLayout__OI0XO"};